import React from "react";
import { BOOKS_PAGE_BOOKS_LIST_TAB_HEADINGS } from "../../constants/text_constants";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { UNPROTECTED_ROUTES } from "../../routes/routes";

const BooksListHeader = ({ setShowAllBooks, showAllBooks }) => {
  const allBooksCache = useSelector((store) => store.cache.allBooksCache);
  const myBooksCache = useSelector((store) => store.cache.myBooksCache);
  const authenticated = sessionStorage.getItem("authenticated") === "1";
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div
      className="flex justify-between border-b border-gray-200 pb-2 text-[#3F3D4B]"
      style={{ fontFamily: "DM Sans" }}
    >
      <div className="flex lg:gap-5 gap-3 cursor-pointer lg:text-lg text-xs">
        <div
          className={
            location?.pathname === UNPROTECTED_ROUTES?.booksAll
              ? "text-[#03B3C3] underline lg:underline-offset-[0.9rem] underline-offset-[0.75rem] font-semibold"
              : ""
          }
          onClick={() => navigate(UNPROTECTED_ROUTES?.booksAll)}
        >
          {BOOKS_PAGE_BOOKS_LIST_TAB_HEADINGS[0]}
        </div>
        <div
          className={
            location?.pathname === UNPROTECTED_ROUTES?.booksMy
              ? "text-[#03B3C3] underline lg:underline-offset-[0.9rem] underline-offset-[0.75rem] font-semibold"
              : ""
          }
          onClick={() => navigate(UNPROTECTED_ROUTES?.booksMy)}
        >
          {BOOKS_PAGE_BOOKS_LIST_TAB_HEADINGS[1]}
        </div>
      </div>
      {authenticated ? (
        location?.pathname === UNPROTECTED_ROUTES?.booksAll ? (
          <div className="lg:text-lg text-xs">
            Total Books : {allBooksCache[0]?.total}
          </div>
        ) : (
          <div className="lg:text-lg text-xs">
            Purchased Books : {myBooksCache[0]?.total}
          </div>
        )
      ) : location?.pathname === UNPROTECTED_ROUTES?.booksMy ? (
        <div className="lg:text-lg text-xs">Purchased Books : 0</div>
      ) : (
        <div className="lg:text-lg text-xs">
          Total Books : {allBooksCache[0]?.total}
        </div>
      )}
    </div>
  );
};

export default BooksListHeader;
